import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Card, NumberPage } from '@/types/financial-workspace';

export type CardState = {
  data: Card[];
  detail: Card | null;
  pagination: NumberPage<Card>;
  loading: boolean;
  error: string;
};

const emptyPage: NumberPage<Card> = {
  items: [],
  pageNumber: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  hasPrevious: false,
  hasNext: false,
};

export const cardInitialState: CardState = {
  data: [],
  detail: null,
  pagination: emptyPage,
  loading: false,
  error: '',
};

const slice = createSlice({
  name: 'card',
  initialState: cardInitialState,
  reducers: {
    setCardsAction(state, { payload }: PayloadAction<NumberPage<Card>>) {
      state.data = payload.items;
      state.pagination = payload;
      state.error = '';
    },
    setCardDetailAction(state, { payload }: PayloadAction<Card | null>) {
      state.detail = payload;
    },
    updateCardAction(state, { payload }: PayloadAction<Card>) {
      state.data = state.data.map((card) => card.id === payload.id ? payload : card);
      if (state.detail?.id === payload.id) state.detail = payload;
    },
    setCardLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setCardError(state, { payload }: PayloadAction<string>) {
      state.error = payload;
    },
    resetCardStateAction: () => cardInitialState,
  },
});

export const {
  setCardsAction,
  setCardDetailAction,
  updateCardAction,
  setCardLoading,
  setCardError,
  resetCardStateAction,
} = slice.actions;

export default slice.reducer;
